import { useState } from "react";
import { useLang } from "../../i18n/LanguageContext";

const allProjects = [
  {
    title: "Mall El Arab",
    type: "commercial",
    img: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80&w=600",
    scope: "Complete Fire Fighting & Alarm Systems",
    year: "2023",
  },
  {
    title: "Dar Al Fouad Hospital",
    type: "healthcare",
    img: "https://images.unsplash.com/photo-1516549655169-df83a0774514?auto=format&fit=crop&q=80&w=600",
    scope: "Clean Agent Suppression & LV Switchboards",
    year: "2022",
  },
  {
    title: "Mereco Industrial Plant",
    type: "industrial",
    img: "https://images.unsplash.com/photo-1513828583688-c52646db42da?auto=format&fit=crop&q=80&w=600",
    scope: "MV Grid, Fire Pump Stations, NFPA 20",
    year: "2023",
  },
  {
    title: "East Asia Stores HQ",
    type: "commercial",
    img: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=600",
    scope: "LV Distribution & Addressable Fire Alarm",
    year: "2022",
  },
  {
    title: "El Obour Industrial Zone",
    type: "infrastructure",
    img: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&q=80&w=600",
    scope: "Underground Piping & MV Switchgear",
    year: "2021",
  },
  {
    title: "Al Shorouk Medical Center",
    type: "healthcare",
    img: "https://images.unsplash.com/photo-1586773860418-d37222d8fce3?auto=format&fit=crop&q=80&w=600",
    scope: "FM-200 Suppression & Voice Evacuation",
    year: "2023",
  },
  {
    title: "Cairo North Power Station",
    type: "infrastructure",
    img: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?auto=format&fit=crop&q=80&w=600",
    scope: "Ring Main Units & Step-Down Transformers",
    year: "2022",
  },
  {
    title: "Green Hills Factory",
    type: "industrial",
    img: "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?auto=format&fit=crop&q=80&w=600",
    scope: "Foam Deluge & Industrial Booster Pumps",
    year: "2021",
  },
];

const sectorIcons = { industrial: "fa-industry", commercial: "fa-building", healthcare: "fa-hospital", infrastructure: "fa-bridge" };

export default function Projects() {
  const { t } = useLang();
  const [active, setActive] = useState("all");
  const filters = Object.keys(t.projects.filters);
  const filtered = active === "all" ? allProjects : allProjects.filter((p) => p.type === active);

  return (
    <section id="projects" className="py-32 bg-[#141416] border-t border-b border-white/5 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between mb-16 gap-6">
          <div className="space-y-4">
            <div className="text-[#F28C18] uppercase text-xs font-black tracking-widest">{t.projects.label}</div>
            <h2 className="text-3xl sm:text-5xl font-black tracking-tight text-white uppercase">{t.projects.title}</h2>
          </div>
          <div className="flex flex-wrap gap-2 text-xs font-bold uppercase tracking-widest">
            {filters.map((f) => (
              <button
                key={f}
                onClick={() => setActive(f)}
                className={`px-4 py-2.5 rounded cursor-pointer transition-all ${
                  active === f ? "bg-[#F28C18] text-black" : "bg-white/5 text-zinc-400 hover:text-white"
                }`}
              >
                {t.projects.filters[f]}
              </button>
            ))}
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {filtered.map((p) => (
            <div
              key={p.title}
              className="relative rounded min-h-[300px] flex flex-col justify-end overflow-hidden border border-white/5 border-b-4 border-zinc-700 hover:border-[#F28C18] group cursor-pointer bg-zinc-900 transition-all"
            >
              <img
                src={p.img}
                alt={p.title}
                className="absolute inset-0 w-full h-full object-cover opacity-25 group-hover:opacity-55 transition-all duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#111112] via-[#111112]/55 to-transparent" />
              <div className="relative z-20 p-6 space-y-2">
                <i className={`fas ${sectorIcons[p.type] || "fa-building"} text-xl text-[#F28C18]`} />
                <h4 className="text-sm font-black text-white uppercase">{p.title}</h4>
                <p className="text-[11px] text-zinc-400 leading-relaxed">{p.scope}</p>
                <div className="flex items-center justify-between pt-2">
                  <span className="text-[10px] text-zinc-600 font-bold">{p.year}</span>
                  <span className="text-[10px] text-[#F28C18] font-black tracking-widest uppercase group-hover:underline">
                    {t.projects.viewDetails} →
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
